<div>
  <div class="search-by-cust-or-policy">

    <ng-container *ngIf="searchMode === allowedSearchModes.policySearchOnlyBasedOnClientOrPolicyData">
      <!-- Search by ? -->
      <h3>Search by</h3>
      <nz-radio-group [(ngModel)]="currentSearchPanel" (ngModelChange)="animateLoad()" [nzButtonStyle]="'solid'"
        [nzSize]="'default'">
        <label nz-radio-button nzValue="CLIENT">
          <i nz-icon nzType="user" nzTheme="outline"></i> Client
        </label>
        <label nz-radio-button nzValue="POLICY">
          <i nz-icon nzType="file-protect" nzTheme="outline"></i> Policy
        </label>
      </nz-radio-group>
    </ng-container>

    <ng-container *ngIf="searchMode === allowedSearchModes.customerSearchOrCapture">
      <!-- Search by ? -->

      <nz-radio-group [(ngModel)]="currentSearchPanel" ngDefaultControl (ngModelChange)="animateLoad()" [nzButtonStyle]="'solid'"
        [nzSize]="'default'">
        <label id="radioSearch" nz-radio-button nzValue="CLIENT">
          <i nz-icon nzType="user" nzTheme="outline"></i> Search {{captureRole}}
        </label>
        <label nz-radio-button nzValue="CAPTURECLIENT">
          <i nz-icon nzType="file-protect" nzTheme="outline"></i> Add New {{captureRole}}
        </label>
      </nz-radio-group>
    </ng-container>

    <app-agent-search (componentOutput)="fetchOutputFromAgentChild($event)" [clientRole]="captureRole"
      *ngIf="currentSearchPanel=='CLIENT' && captureRole === 'Agent'">
    </app-agent-search>

    <!-- Client Search -->
    <app-client-search (componentOutput)="fetchOutputFromChild($event)" [clientRole]="captureRole"
      [custSearchFor]="custSearchFor" #clientSearch *ngIf="currentSearchPanel=='CLIENT' && captureRole !== 'Agent'">
    </app-client-search>

    <!-- Policy Search -->
    <app-policy-search *ngIf="currentSearchPanel=='POLICY'">
    </app-policy-search>

    <!-- Add new Client -->
    <app-capture-client-details *ngIf="currentSearchPanel=='CAPTURECLIENT' && captureRole !== 'Agent'"
      [inputDataForEdit]="editableClient" [modalFlag]="modalFlag" (changedField)="getChangeField($event)" [(clientRole)]="_captureRoleKey">
    </app-capture-client-details>

  </div>
</div>